import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=106abb1d&scoped=true&"
import script from "./helpCenter.vue?vue&type=script&lang=js&"
export * from "./helpCenter.vue?vue&type=script&lang=js&"
import style0 from "./helpCenter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./helpCenter.vue?vue&type=style&index=1&id=106abb1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106abb1d",
  null
  
)

export default component.exports